import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundFilter'
})
export class RoundFilterPipe implements PipeTransform {
  transform(value: any, decimal?: any): any {
    const puissance = decimal ? decimal : 2;
    const mult = (Math.pow(10, puissance));
    const roundedValue = Math.round(parseFloat(value) * mult / mult);
    return roundedValue;
  }

}
